import { PhysicsEngine } from "../../physics-experiment/src/core/lab-engine.js";
import { SceneManager } from "../../physics-experiment/src/scene/scene-manager.js";
import { HttpReporter } from "../../physics-experiment/src/telemetry/http-reporter.js";
import { listExperimentSlugs, loadExperimentPack } from "./data/pack-loader.js";

function randomId(prefix: string): string {
  return `${prefix}_${Math.random().toString(36).slice(2)}_${Date.now()}`;
}

/** 本地联调默认值：对齐 source/plugin-server-demo 的 DEMO_USER token（tech/108 §8.3）。 */
const DEFAULT_API_BASE_URL = "http://127.0.0.1:8000/api/v1";
const DEFAULT_TOKEN = "demo-token-lishanming";

function mount(): void {
  const root = document.getElementById("app");
  if (!root) throw new Error("[physics-mission] 找不到 #app 挂载点");

  // `?exp=` 选包（todo/068）：显式默认 "friction-basic"，不再隐式取字母序第一个——
  // 保证现有 footer 链接 `/physics-mission/`（不带 query）加载的实验零变化。
  const available = listExperimentSlugs();
  const requested = new URLSearchParams(window.location.search).get("exp");
  const slug = requested && available.includes(requested) ? requested : "friction-basic";
  if (!available.includes(slug)) throw new Error("[physics-mission] experiments/ 下没有任何实验包");

  const apiBaseUrl = import.meta.env.VITE_PHYSICS_API_BASE_URL ?? DEFAULT_API_BASE_URL;
  const token = import.meta.env.VITE_PHYSICS_API_TOKEN ?? DEFAULT_TOKEN;

  const engine = new PhysicsEngine({
    instanceId: randomId("instance"),
    sessionId: randomId("session"),
    reporter: new HttpReporter({ endpoint: `${apiBaseUrl}/physics/events`, token }),
  });
  const pack = loadExperimentPack(slug);
  engine.load(pack);
  document.title = pack.experiment.title;

  const scene = new SceneManager({ engine, root });
  scene.mount();
  engine.start();
}

mount();
